module.exports = __webpack_public_path__ + "images/tabs/deals-off.png";